import {
  EuiButton,
  EuiComboBoxOptionOption,
  EuiEmptyPrompt,
  euiPaletteColorBlindBehindText,
  EuiSpacer,
  EuiTableSelectionType,
} from "@elastic/eui";
import {
  Box,
  Button,
  Flex,
  Grid,
  Input,
  MultiSelect,
  MultiSelectProps,
  Text,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDebouncedValue } from "@mantine/hooks";
import {
  IconBuilding,
  IconCheck,
  IconFilter,
  IconSearch,
  IconTag,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { ReactNode, useEffect, useState } from "react";
import { styleTableMantine } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../../_base/extension/StringExtension";
import Repository from "../../../../_base/helper/HttpHelper";
import { ParamSearchBase } from "../../../../_base/model/_base/ParamSearchBase";
import { getDataListProduct } from "../../../../api/ApiProduct";
import { getDataBrand, getDataBrandV2 } from "../../../../api/ApiSell";
import { _localization } from "../../../../config/location";
import { Brand, TblItemCommand } from "../../../../model/ProductList";
import { SelectListItemModel } from "../../../../model/SelectListItem copy";

const noItemsFoundMsg = "Không có kết quả tìm kiếm phù hợp...";

const visColorsBehindText = euiPaletteColorBlindBehindText();

export interface selectedSearchOptionType {
  features?: EuiComboBoxOptionOption<string>[];
  searchType?: EuiComboBoxOptionOption<number>[];
  brandId?: EuiComboBoxOptionOption<number>[];
}

interface SearchCriteria {
  keySearch?: string;
  StatusFilter?: string[];
  SearchType?: string[];
  BrandId?: string[];
}

const FormChooseItemFrame = ({
  onChooseItem,
  idBST,
  onSearch,
  selectedProductIds = [],
}: FormChooseItemProps) => {
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });
  const [toltal, setTotal] = useState(0);
  const [dataBrand, setDataBrand] = useState<Brand[]>();

  // State để track các sản phẩm đã chọn trong session hiện tại
  const [localSelectedProductIds, setLocalSelectedProductIds] =
    useState<number[]>(selectedProductIds);

  const columns = React.useMemo<MRT_ColumnDef<TblItemCommand>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row.index + 1}</>,
        size: 50,
      },
      {
        header: "ID",
        accessorKey: "id",
        size: 60,
      },
      {
        header: "Tên sản phẩm",
        accessorKey: "itemName",
        size: 250,
        Cell: ({ row }) => <a href="#">{row.original.itemName}</a>,
      },
      {
        header: "Mã sản phẩm",
        accessorKey: "itemCode",
        size: 140,
      },
      {
        header: "Ảnh",
        accessorKey: "primaryImage",
        size: 100,
        Cell: ({ row }) => {
          const imageUrl = row.original.primaryImage;
          return imageUrl ? (
            <img
              src={imageUrl}
              alt="Ảnh sản phẩm"
              width={60}
              height={80}
              style={{ objectFit: "contain" }}
            />
          ) : (
            <span style={{ color: "#999", fontSize: "12px" }}>
              Không có ảnh
            </span>
          );
        },
      },
      {
        header: "Thương hiệu",
        accessorKey: "brandId",
        size: 130,
        Cell: ({ row }) => {
          const brand = dataBrand?.find(
            (b: any) => b.id === row.original.brandId
          );
          return <a href="#">{brand?.name ?? "---"}</a>;
        },
      },
      {
        header: "Giá bán",
        accessorKey: "unitSellingPrice",
        size: 130,
        Cell: ({ cell }) => (
          <Box style={{ display: "flex", alignItems: "center" }}>
            <Text fw={600} c="red" mr={4}>
              {convertToVnd(cell.getValue<number>())}
            </Text>
            <Text>vnd</Text>
          </Box>
        ),
      },
      {
        header: "Giảm giá",
        accessorKey: "discountValue",
        size: 150,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Box style={{ display: "flex", alignItems: "center" }}>
              <Text size="sm">Giảm giá:</Text>
              <Text fw={600} c="red" ml={4}>
                {row.original.discountValue
                  ? `${row.original.discountValue}%`
                  : "0%"}
              </Text>
            </Box>
            <Text size="xs" c="gray">
              so với giá gốc
            </Text>
          </Box>
        ),
      },
      {
        header: "Số lượng tồn kho",
        accessorKey: "onhandQuantyty",
        size: 180,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Box style={{ display: "flex", alignItems: "center" }}>
              <Text size="sm">Số lượng tổng:</Text>
              <Text fw={600} c="red" ml={4}>
                {row.original.onhandQuantyty}
              </Text>
            </Box>
            {row.original.onhandQuantyty === 0 ? (
              <Text size="xs" c="red">
                hết hàng
              </Text>
            ) : (
              <Text size="xs" c="blue">
                còn hàng
              </Text>
            )}
          </Box>
        ),
      },
      {
        header: "Thông tin bảo hành",
        accessorKey: "warrantyDescrition",
        size: 300,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Box style={{ display: "flex", alignItems: "center" }}>
              <Text size="sm">Thời hạn:</Text>
              <Text fw={600} c="blue" ml={4}>
                {row.original.warrantyDescrition || "Chưa có thông tin"}
              </Text>
            </Box>
          </Box>
        ),
      },
      {
        header: "Thao tác",
        accessorKey: "action",
        enableSorting: false,
        enableColumnActions: false,
        size: 150,
        Cell: ({ row }) => {
          const isSelected = localSelectedProductIds.includes(row.original.id);
          return isSelected ? (
            <Button variant="filled" color="green" disabled>
              Đã chọn
            </Button>
          ) : (
            <Button onClick={() => onAddMutiItem(row.original)}>
              Chọn sản phẩm
            </Button>
          );
        },
      },
    ],
    [dataBrand, localSelectedProductIds]
  );
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<TblItemCommand[]>([]);
  const [message, setMessage] = useState<ReactNode>(
    <EuiEmptyPrompt
      title={<h3>Dữ liệu rỗng !</h3>}
      titleSize="xs"
      body="Tải lại dữ liệu nếu trường hợp bạn không thấy có dữ liệu hiển thị !"
      actions={
        <EuiButton
          size="s"
          key="loadUsers"
          onClick={async () => {
            await fetchDataItem();
          }}
        >
          Tải dữ liệu !
        </EuiButton>
      }
    />
  );
  const [sortField, setSortField] = useState<keyof TblItemCommand>("itemName");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [error, setError] = useState<string | undefined>();
  // const [pagination, setPagination] = useState<Pagination>(paginationBase);
  const [selectedOptions, setSelected] = useState();
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [selectedItemFiltering, setSelectedItemFiltering] = useState<
    string | null
  >();
  const [selectedItemArrangements, setSelectedItemArrangements] = useState<
    string | null
  >();
  const [selectedSearchOption, setSelectedSearchOption] =
    useState<selectedSearchOptionType>();
  const [dataBrandOption, setDataBrandOption] = useState<SelectListItemModel[]>(
    []
  );
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue] = useDebouncedValue(searchValue, 400);

  const fetchDataItem = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;
    const search = form.getValues();
    const keySearchObj = {
      KeySearch: search.keySearch?.trim().toLowerCase() || "",
      StatusFilter: search.StatusFilter || [], //chưa có trường tryền vào để lọc thuộc tính
      SearchType: search.SearchType || [],
      BrandId: search.BrandId || [],
    };
    // Xây dựng URL từ keySearchObj
    Object.entries(keySearchObj).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          url += `&${key}=${encodeURIComponent(item)}`;
        });
      } else if (value) {
        url += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    // if (search.keySearch) {
    //   url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
    // }
    // if (search.StatusFilter) {
    //   url += `&StatusFilter=${search.StatusFilter} `;
    // }
    // if (search.SearchType) {
    //   url += `&SearchType=${search.SearchType}`;
    // }
    // if (search.BrandId) {
    //   url += `&BrandId=${search.BrandId}`;
    // }

    try {
      let response = await getDataListProduct(url);
      // if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
      //   setMessage(noItemsFoundMsg);
      //   setTotal(0);
      // } else {
      //   setUsers(callapi?.data || []);
      //   setPagination({
      //     ...pagination,
      //     totalItemCount: callapi?.totalCount ?? 0,
      //   });
      //   setTotal(callapi?.totalCount ?? 0);
      // }
      if (response && response.data && response.success) {
        let result = response.data;
        setUsers(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
      // return response.data.data;
    } catch (error) {
      setUsers([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  // const onTableChange = async ({
  //   page: { index, size },
  //   sort,
  // }: CriteriaWithPagination<TblItemCommand>) => {
  //   setPagination({ ...pagination, pageIndex: index, pageSize: size });
  //   if (sort) {
  //     const { field: sortField, direction: sortDirection } = sort;
  //     setSortField(sortField);
  //     setSortDirection(sortDirection);
  //   }
  // };

  // const onChangeSelectedSearch = (
  //   value:
  //     | EuiComboBoxOptionOption<string>[]
  //     | EuiComboBoxOptionOption<number>[],
  //   key: string
  // ) => {
  //   const dataSearchOption = { ...selectedSearchOption };
  //   dataSearchOption[key as keyof selectedSearchOptionType] = value as any[];
  //   setSelectedSearchOption(dataSearchOption);
  // };
  // const onChange = (selectedOptions: any) => {
  //   setSelected(selectedOptions);
  //   if (!isNullOrUndefinedArry(selectedOptions)) {
  //     const value = selectedOptions[0].value;
  //     if (!isNullOrUndefined(value))
  //       setParamSearch({ ...paramSearch, inActive: value });
  //   } else setParamSearch({ ...paramSearch, inActive: undefined });
  // };

  // const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const key = event?.target?.value;
  //   if (!isNullOrUndefined(key))
  //     setParamSearch({ ...paramSearch, keyWord: key });
  // };

  function convertToVnd(amount: number): string {
    const amountStr: string = amount?.toString();
    const chunks: string[] = [];

    for (let i = amountStr?.length - 1; i >= 0; i -= 3) {
      const chunk = amountStr?.slice(Math.max(i - 2, 0), i + 1);
      chunks.push(chunk);
    }

    const result: string = chunks.reverse().join(".");
    return result;
  }

  const [isSelectedItem, setSelectedItems] = useState<TblItemCommand[]>([]);

  const onSelectionChange = (selectedItems: TblItemCommand[]) => {
    setSelectedItems(selectedItems);
  };
  const selection: EuiTableSelectionType<TblItemCommand> = {
    selectable: (data: TblItemCommand) => true,
    selectableMessage: (selectable: boolean) =>
      !selectable ? "User is currently offline" : "",
    onSelectionChange,
  };

  const onAddMutiItem = async (item?: TblItemCommand) => {
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    if (!item && isSelectedItem?.length === 0) {
      NotificationExtension.Warn(
        "Vui lòng chọn sản phẩm trước khi thêm vào bộ sưu tập !"
      );
    } else {
      let dataSubmit;
      let productIdsToAdd: number[] = [];

      if (item && !isNullOrUndefined(item)) {
        dataSubmit = [item?.itemCode];
        productIdsToAdd = [item.id];
      } else {
        dataSubmit = isSelectedItem.map((item) => {
          return {
            productId: item.id,
            ordering: 0,
          };
        });
        productIdsToAdd = isSelectedItem.map((item) => item.id);
      }
      try {
        const res = await repository.post(`/TblKhung/add-products`, {
          khungId: idBST,
          productCodes: dataSubmit,
        });
        if (res && res.success) {
          NotificationExtension.Success(
            "Thêm sản phẩm vào bộ sưu tập thành công !"
          );
        } else {
          NotificationExtension.Fails(
            "Thêm sản phẩm vào bộ sưu tập thất bại !"
          );
        }

        // Cập nhật localSelectedProductIds ngay lập tức
        setLocalSelectedProductIds((prev) => [...prev, ...productIdsToAdd]);

        if (onSearch) {
          await onSearch();
        }
      } catch (error) {
        console.error("Error adding item to collection:", error);
      }
      // modals.closeAll();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataItem();
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);
  useEffect(() => {
    const fetDatabrand = async () => {
      const data = await getDataBrand();
      setDataBrand(data?.data.lists);
    };
    fetDatabrand();
  }, []);

  // Đồng bộ localSelectedProductIds với selectedProductIds khi prop thay đổi
  useEffect(() => {
    setLocalSelectedProductIds(selectedProductIds);
  }, [selectedProductIds]);
  // useEffect(() => {
  //   if (dataBrand)
  //     setDataBrandOption(
  //       dataBrand.map((brand, index) => ({
  //         value: brand.id,
  //         label: brand.name,
  //       }))
  //     );
  // }, [dataBrand]);
  const table = useMantineReactTable({
    columns,
    data: users,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      // rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ["mrt-row-select", "STT"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    // onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const searchOption = {
    StatusFilter: [
      {
        value: "1",
        label: "Mới",
        color: visColorsBehindText[0],
      },
      {
        value: "2",
        label: "Hot (hỏi nhiều)",
        color: visColorsBehindText[1],
      },
      {
        value: "3",
        label: "Bán chạy",
        color: visColorsBehindText[2],
      },
      {
        value: "4",
        label: "Xả hàng (sale-off)",
        color: visColorsBehindText[3],
      },
      {
        value: "5",
        label: "Chỉ bán online",
        color: visColorsBehindText[4],
      },
    ],
    searchType: [
      {
        value: "1",
        label: "Giá bán = 0",
        color: visColorsBehindText[0],
      },
      {
        value: "2",
        label: "Còn hàng",
        color: visColorsBehindText[1],
      },
      {
        value: "3",
        label: "Hết hàng",
        color: visColorsBehindText[2],
      },
      {
        value: "4",
        label: "Có giá thị trường",
        color: visColorsBehindText[3],
      },
      // {
      //   value: "5",
      //   label: "Có khuyến mại",
      //   color: visColorsBehindText[4],
      // },
      // {
      //   value: "6",
      //   label: "Có cấu hình",
      //   color: visColorsBehindText[5],
      // },
      {
        value: "7",
        label: "Có mã kho",
        color: visColorsBehindText[6],
      },
      {
        value: "8",
        label: "Chưa có mã kho",
        color: visColorsBehindText[7],
      },
      {
        value: "9",
        label: "Chưa có ảnh",
        color: visColorsBehindText[8],
      },
      {
        value: "10",
        label: "Chưa có ảnh sản phẩm",
        color: visColorsBehindText[9],
      },
      {
        value: "11",
        label: "Chưa có ảnh khách hàng",
        color: visColorsBehindText[10],
      },
      {
        value: "12",
        label: "Chưa có ảnh Hacom tự chụp",
        color: visColorsBehindText[11],
      },
      {
        value: "13",
        label: "Chưa hiển thị",
        color: visColorsBehindText[12],
      },
      {
        value: "14",
        label: "Đang hiển thị",
        color: visColorsBehindText[13],
      },
      {
        value: "15",
        label: "Chưa có danh mục",
        color: visColorsBehindText[14],
      },
      {
        value: "16",
        label: "Chưa mô tả",
        color: visColorsBehindText[15],
      },
      {
        value: "17",
        label: "Chưa có thông số nhập text",
        color: visColorsBehindText[16],
      },
      {
        value: "18",
        label: "Chưa có mô tả tóm tắt",
        color: visColorsBehindText[17],
      },
    ],
  };

  const fetchDataBrand = async (keySearch?: string) => {
    try {
      let url = "?Skip=0&Take=1000";
      if (keySearch) {
        url += `&KeySearch=${keySearch}`;
      }
      const response = await getDataBrandV2(url);
      if (response && response.data.lists) {
        const formattedData = response.data.lists
          .filter((i: any) => i.id && i.name)
          .map((item: any, index: number) => ({
            value: item.id.toString(),
            label: item.name,
          }));
        setDataBrandOption(formattedData);
      }
    } catch (error) {
      console.log("error fetchDataBrand", error);
    }
  };
  useEffect(() => {
    if (debouncedSearchValue) {
      fetchDataBrand(debouncedSearchValue);
    }
  }, [debouncedSearchValue]);
  const renderMultiSelectOptionAttribute: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text>
        {
          searchOption?.StatusFilter?.find((x: any) => x.value === option.value)
            ?.label
        }
      </Text>
    </Flex>
  );
  const renderMultiSelectOptionBrandId: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text size="sm">
        {dataBrandOption.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Flex>
  );
  return (
    <>
      {/* <ProductListSearch
        loading={loading}
        onChangeSelectedSearch={onChangeSelectedSearch}
        selectedSearchOption={selectedSearchOption}
        onChangeText={onChangeText}
        onSearch={onSearch ?? (() => {})}
        dataBrandOption={dataBrandOption}
        onAddMutiItem={onAddMutiItem}
      /> */}
      <Grid mt={10}>
        <Grid.Col style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <Input
            placeholder="Nhập tìm kiếm"
            key={form.key("keySearch")}
            type="text"
            leftSection={<IconSearch size={"20"} color="#15aabf" />}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await fetchDataItem();
              }
            }}
            size="md"
            {...form.getInputProps("keySearch")}
          />
          <MultiSelect
            searchable
            clearable
            placeholder="Đặc điểm sản phẩm"
            size="md"
            leftSection={<IconTag color="#15aabf" />}
            data={searchOption.StatusFilter || []}
            renderOption={renderMultiSelectOptionAttribute}
            key={form.key("StatusFilter")}
            {...form.getInputProps("StatusFilter")}
            classNames={{
              dropdown: "custom-multiselect-dropdown",
            }}
            maxDropdownHeight={700}
          />
          <MultiSelect
            searchable
            clearable
            placeholder="Xét theo điều kiện"
            size="md"
            leftSection={<IconFilter color="#15aabf" />}
            data={searchOption.searchType || []}
            key={form.key("SearchType")}
            {...form.getInputProps("SearchType")}
            classNames={{
              dropdown: "custom-multiselect-dropdown",
            }}
            maxDropdownHeight={700}
          />
          <MultiSelect
            size="md"
            placeholder="Xem theo thương hiệu"
            searchable
            clearable
            data={dataBrandOption || []}
            renderOption={renderMultiSelectOptionBrandId}
            leftSection={<IconBuilding size={20} color="#15aabf" />}
            onClick={() => {
              if (dataBrandOption.length === 0) {
                fetchDataBrand();
              }
            }}
            onSearchChange={(value) => {
              setSearchValue(value); // Cập nhật giá trị tìm kiếm gốc
            }}
            key={form.key("BrandId")}
            {...form.getInputProps("BrandId")}
            classNames={{
              dropdown: "custom-multiselect-dropdown",
            }}
            maxDropdownHeight={700}
          />
          <Button
            size="md"
            color="blue"
            variant="outline"
            onClick={async () => {
              await fetchDataItem();
            }}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>
      <EuiSpacer size="l" />
      <MantineReactTable table={table} />
      {/* <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={users ? users : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={isNullOrUndefinedArry(users) ? message : ""}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
        selection={selection}
      /> */}
    </>
  );
};

type FormChooseItemProps = {
  onChooseItem: (prodId: number) => void;
  idBST: number;
  onSearch?: () => void;
  selectedProductIds?: number[];
};

export default FormChooseItemFrame;
